export default __webpack_public_path__ + "static/media/caloriesIntake.c5a3d834.png";